import React, { useState } from 'react';
import { useTranslate } from '../../../components/TranslationText';
import NetaqInput from '../../../components/NetaqInput';

const DynamicTableForm = ({ isVIPHorse }) => {
  const { translate } = useTranslate();
  const [rows, setRows] = useState([
    { id: 1, text1: '', date: '', text2: '', text3: '' }
  ]);

  const handleAddRow = () => {
    const newId = rows.length > 0 ? Math.max(...rows.map(row => row.id)) + 1 : 1;
    const newRow = {
      id: newId,
      text1: '',
      date: '',
      text2: '',
      text3: ''
    };
    setRows([...rows, newRow]);
  };

  const handleDeleteRow = (id) => {
    if (rows.length == 1) {
      return;
    }
    const updatedRows = rows.filter(row => row.id !== id);
    setRows(updatedRows);
  };

  const handleInputChange = (id, field, value) => {
    const updatedRows = rows.map(row =>
      row.id === id ? { ...row, [field]: value } : row
    );
    setRows(updatedRows);
  };
  const isVip = isVIPHorse == "true" ? true : false;
  const requiredText = `(${translate('web.required', 'required')})`

  return (
    <div className='scrolableTable mx-auto  w-100 border-15' >
      <table className='table table-striped table-bordered rtl horseResultTable border-15 ' style={{ overflow: 'hidden' }}>
        <thead className='theadHorseSelect'>
          <tr className='text-center'>
            <th>{translate('web.raceName', 'Race Name')} {isVip && requiredText} </th>
            <th>{translate('web.raceClassification', 'Race Classification')} {isVip && requiredText} </th>
            <th>{translate('web.raceDate', 'Race Date')} {isVip && requiredText}</th>
            <th>{translate('web.rank', 'Rank')} {isVip && requiredText}</th>
            <th className='text-center'>{translate('web.action', 'Action')} </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={row.id}>
              <td>
                <NetaqInput
                  type='text'
                  label={translate('web.raceName', 'Race Name')}
                  placeholder={translate('web.raceName', 'Race Name')}
                  hideLable
                  name='raceName'
                  value={row.text1}
                  onChange={(e) => handleInputChange(row.id, 'text1', e.target.value)}
                />
              </td>
              <td>
                <NetaqInput
                  type='text'
                  label={translate('web.raceClassification', 'Race Classification')}
                  placeholder={translate('web.raceClassification', 'Race Classification')}
                  hideLable
                  name='raceClassification'
                  value={row.text2}
                  onChange={(e) => handleInputChange(row.id, 'text2', e.target.value)}
                />
              </td>
              <td>
                <NetaqInput
                  type='normalDate'
                  label={translate('web.raceDate', 'Race Date')}
                  hideLable
                  name='raceDate'
                  value={row.date}
                  onChange={(e) => handleInputChange(row.id, 'date', e.target.value)}
                />
              </td>
              <td>
                <NetaqInput
                  type='text'
                  label={translate('web.rank', 'Rank')}
                  placeholder={translate('web.rank', 'Rank')}
                  hideLable
                  name='rank'
                  value={row.text3}
                  onChange={(e) => handleInputChange(row.id, 'text3', e.target.value)}
                />
              </td>
              <td className='text-center'>
                {((index + 1) != rows.length) ?
                  <div
                    className="btn btn-danger w-unset text-center  border-15"
                    onClick={() => handleDeleteRow(row.id)}
                    title={translate('web.delete', 'Delete')}
                  >
                    <i className="fa fa-trash w-unset" aria-hidden="true"></i>
                  </div>
                  :
                  <>
                    <div
                      className="btn btn-danger w-unset text-center  border-15"
                      onClick={() => handleDeleteRow(row.id)}
                      title={translate('web.delete', 'Delete')}
                    >
                      <i className="fa fa-trash w-unset" aria-hidden="true"></i>
                    </div>
                    <div
                      className="btn btn-dark w-unset text-center ms-3 border-15"
                      onClick={handleAddRow}
                      title={translate('web.add', 'Add')}
                    >
                      <i className="fa fa-plus w-unset" aria-hidden="true"></i>
                    </div>
                  </>
                }
              </td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );
};

export default DynamicTableForm;